/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateClaimLink201Response
 */
export interface CreateClaimLink201Response {
    /**
     * 
     * @type {number}
     * @memberof CreateClaimLink201Response
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof CreateClaimLink201Response
     */
    claimId: number;
    /**
     * 
     * @type {number}
     * @memberof CreateClaimLink201Response
     */
    companyId: number;
    /**
     * Display label for the link
     * @type {string}
     * @memberof CreateClaimLink201Response
     */
    label: string;
    /**
     * Full URL (must include protocol)
     * @type {string}
     * @memberof CreateClaimLink201Response
     */
    url: string;
    /**
     * 
     * @type {number}
     * @memberof CreateClaimLink201Response
     */
    readonly createdBy: number;
    /**
     * 
     * @type {Date}
     * @memberof CreateClaimLink201Response
     */
    readonly createdAt: Date;
}

/**
 * Check if a given object implements the CreateClaimLink201Response interface.
 */
export function instanceOfCreateClaimLink201Response(value: object): value is CreateClaimLink201Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function CreateClaimLink201ResponseFromJSON(json: any): CreateClaimLink201Response {
    return CreateClaimLink201ResponseFromJSONTyped(json, false);
}

export function CreateClaimLink201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClaimLink201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'companyId': json['companyId'],
        'label': json['label'],
        'url': json['url'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function CreateClaimLink201ResponseToJSON(json: any): CreateClaimLink201Response {
    return CreateClaimLink201ResponseToJSONTyped(json, false);
}

export function CreateClaimLink201ResponseToJSONTyped(value?: Omit<CreateClaimLink201Response, 'id'|'createdBy'|'createdAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'companyId': value['companyId'],
        'label': value['label'],
        'url': value['url'],
    };
}

